<template>
    <div
        class="flex flex-col rounded-xl border-solid border @container"
        :class="props.selected ? 'border-sky-200 bg-sky-50 ' : 'border-slate-100 bg-white'"
    >
        <div class="flex flex-col items-stretch justify-between gap-1 p-0.5 @xl:flex-row @xl:items-center @xl:pr-0">
            <div
                class="group/checkbox flex grow cursor-pointer items-start gap-2 rounded-l-lg rounded-r-sm py-4 px-3 @xl:px-4 transition @xl:items-center"
                :class="props.selected ? 'hover:bg-sky-100/50' : 'hover:bg-sky-50/50'"
                role="button"
                tabindex="0"
                :data-test="`toggle-snippet-${snippet.snippet_id}`"
                @click.prevent="emit('selected')"
                @keydown.space.prevent="emit('selected')"
                @keydown.enter.prevent="emit('selected')"
            >
                <div
                    class="relative mt-0.5 transition duration-150 group-hover/checkbox:scale-110 group-hover/checkbox:duration-300 group-hover/checkbox:ease-[cubic-bezier(0.5,4,0.4,1)] group-active/checkbox:scale-95 group-active/checkbox:duration-150 group-active/checkbox:ease-in-out @xl:mt-0"
                >
                    <div
                        class="flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-solid border-slate-400"
                    ></div>

                    <div
                        class="absolute top-0 z-0 flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-solid border-sky-500 bg-sky-300 transition"
                        :class="props.selected ? '' : 'border-slate-400 bg-white '"
                    >
                        <font-awesome-icon
                            widthAuto
                            data-test="selected-icon"
                            :icon="faCheck"
                            class="!size-2.5 transition"
                            :class="props.selected ? '' : 'opacity-0'"
                        ></font-awesome-icon>
                    </div>
                </div>

                <div
                    class="grow origin-left text-sm leading-tight transition duration-150 ease-in-out break-all group-active/checkbox:-translate-x-[1.5px]"
                >
                    <highlighter
                        :searchWords="props.search ? [props.search] : []"
                        :autoEscape="true"
                        highlightClassName="text-amber-600 p-0 bg-transparent"
                        :textToHighlight="
                            'snippet_name' in props.snippet && props.snippet.snippet_name
                                ? props.snippet.snippet_name
                                : 'Loading...'
                        "
                    >
                    </highlighter>
                </div>

                <vx-popover
                    v-if="'deleted_at' in props.snippet && props.snippet.deleted_at"
                    hover
                    :arrow="true"
                    placement="top"
                >
                    <font-awesome-icon widthAuto :icon="faTrashCanXmark"></font-awesome-icon>
                    <template v-slot:content>Deleted</template>
                </vx-popover>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { VxPopover } from '@voxie/frontend-components';
import { faCheck, faTrashCanXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Highlighter from 'vue-highlight-words';
import type { SelectedSnippet } from './useAnalyticsSelectSnippets';

const props = defineProps<{
    snippet: SelectedSnippet;
    selected?: boolean;
    search?: string;
}>();

const emit = defineEmits<{
    selected: [];
}>();
</script>
